// extracted by mini-css-extract-plugin
export var degree = "Profile__degree-zqWlk";
export var name = "Profile__name-sWGjN";
export var wrapper = "Profile__wrapper-YeL5h";